import {
  MusicType,
  SupplierTypeValue
} from '~/config/options.value.c'

/**
 * 存放一些变量，防止魔术字符串的出现
 */

export const STORAGE = {
  TOKEN: 'TOKEN', // 
  USERINFO: 'USERINFO', // 用户信息
  AUTHLIST: 'AUTHLIST', // 权限列表
  LANG: 'LANG', // 语言
  COUNTRY_AREA_OPTIONS: 'COUNTRY_AREA_OPTIONS', // 国家地区
}

export const SESSION_STORAGE = {
  TRANSFER_DATA: 'TRANSFER_DATA', // 传递数据
}

// 一些操作的key值
export const Handle = {
  edit: 'edit',
  add: 'add',
  look: 'look',
  agree: 'agree',
  refuse: 'refuse',
  play: 'play',
  manage: 'manage',
  del: 'del',
  reject: 'reject',
  imme: 'imme',
  operate: 'operate'
}

// 顺序步骤
export const Order = {
  first: '1',
  second: '2',
  third: '3',
  Order: '4'
}

// 加载
export const Load = {
  init: 'init',
  load: 'load',
  loading: 'loading',
  error: 'error',
  end: 'end',
  noMore: 'noMore',
  empty: 'empty'
}

// 公共参数
export const Common = {
  first: 'first',
  second: 'second',
  third: 'third',
  fourth: 'fourth',
  fifth: 'fifth'
}

// 过程变量
export const Process = {
  START: 'start',
  DOING: 'doing',
  FINISHED: 'finish'
}

// 音乐类型
export const MusicTypeText = {
  [MusicType.RS]: 'rs', // 人声
  [MusicType.BGM]: 'bgm', // bgm
  [MusicType.YX]: 'yx', // 音效
}

// 供应商类型
export const SupplierType = {
  MUSICIAN: 'musician',
  TEAM: 'team',
  COMPANY: 'company'
};

// 与后台 value 对应的供应商
export const SupplierValuesToType = {
  [SupplierTypeValue.MUSICIAN]: SupplierType.MUSICIAN,
  [SupplierTypeValue.TEAM]: SupplierType.TEAM,
  [SupplierTypeValue.COMPANY]: SupplierType.COMPANY
}

// 供应商中文对应
export const SupplierTypeDir = {
  [SupplierType.MUSICIAN]: '音乐人',
  [SupplierType.TEAM]: '发行音乐人',
  [SupplierType.COMPANY]: '音乐公司'
}

// 语言
export const LangDir = {
  ZHCN: 'zh_CN',
  EN: 'en'
}

// 默认头像 base64 图
export const defaultHeader = 'data:image/png;base64,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'